import { useReducer } from 'react';
import { LEGAL_ACCEPTED_STORAGE_KEY, FLOATING_BUTTONS_DISMISSED_KEY } from '../constants';
import safeWindow from '../utils/safeWindows';
import { useFalconContext } from '../context/cms-context/FalconContext';
import { useLocalStorage } from './useLocalStorage';
import chatWidgetReducer from '../context/chat-widget-context/reducers/chat-widget-reducer';
import { IAction } from '../context/reducer-factory';
import { getDefaultChatWidgetState } from '../context/chat-widget-context/constants';
import { IChatWidgetState } from '../context/chat-widget-context/types';

export interface IChatWidgetContext {
  state: IChatWidgetState;
  dispatch: React.Dispatch<IAction>;
  launchChat: () => void;
  sendTextMessage: (message: string) => void;
}

export const useInitialChatWidgetState = () => {
  const { cmsContent } = useFalconContext();

  let initialChatWidgetState = getDefaultChatWidgetState(cmsContent);

  const [storedLegalAccepted, setStoredLegalAccepted] = useLocalStorage(
    LEGAL_ACCEPTED_STORAGE_KEY,
    initialChatWidgetState.isLegalAccepted,
    true,
  );

  const isDismissed = safeWindow.sessionStorage?.getItem(FLOATING_BUTTONS_DISMISSED_KEY) === 'true';

  initialChatWidgetState = {
    ...initialChatWidgetState,
    isLegalAccepted: storedLegalAccepted,
    areFloatingButtonsHidden: isDismissed,
  };

  if (cmsContent.chatWidget.floatingButtonsPosition) {
    initialChatWidgetState = {
      ...initialChatWidgetState,
      floatingButtonsPosition: cmsContent.chatWidget.floatingButtonsPosition,
    };
  }

  if (cmsContent.chatWidget.floatingButtonsContainerPosition) {
    initialChatWidgetState = {
      ...initialChatWidgetState,
      position: cmsContent.chatWidget.floatingButtonsContainerPosition,
    };
  }

  const [state, dispatch] = useReducer(chatWidgetReducer, initialChatWidgetState);

  return { initialState: state, dispatch, setStoredLegalAccepted };
};
